import {
  QueryKey,
  useInfiniteQuery,
  UseInfiniteQueryOptions,
} from '@tanstack/react-query'
import { InfiniteQueryKey, ListPagination } from 'api'
import { JsonArrayWithTotal } from 'lib/request'

export const useInfinitePaginatedQuery = <
  TData extends unknown,
  TResult extends JsonArrayWithTotal<TData>,
  TInput extends { pagination: ListPagination },
>(
  queryKey: {
    toKeyWithArgs: (options: TInput & InfiniteQueryKey) => QueryKey
  },
  queryFunction: (input: TInput) => Promise<TResult>,
  input: TInput,
  queryOptions?: UseInfiniteQueryOptions<TResult>,
) => {
  return useInfiniteQuery(
    queryKey.toKeyWithArgs({ infinite: true, ...input }),
    ({ pageParam = 0 }) =>
      queryFunction({
        ...input,
        pagination: {
          pageSize: input.pagination.pageSize,
          page: pageParam,
        },
      }),
    {
      ...queryOptions,
      keepPreviousData: true,
      getNextPageParam: lastPage => lastPage.nextPage,
    },
  )
}
